<template>
  <div class="vehicleSearch">
    <el-card>
      <el-form
        ref="ruleFormRef"
        :inline="true"
        :model="tableParams"
        class="userForm"
      >
        <el-form-item label="车主姓名" prop="name">
          <el-autocomplete
            v-model="tableParams.name"
            :fetch-suggestions="searchAsync"
            :trigger-on-focus="false"
            @select="handleSelect"
            placeholder=""
            clearable
          >
            <template #suffix>
              <div @click="getPoint" style="cursor: pointer">
                <el-icon>
                  <Search></Search>
                </el-icon>
              </div>
            </template>
          </el-autocomplete>
        </el-form-item>
        <!-- 车牌号码 -->
        <el-form-item>
          <HCarPlateNoSelect
            v-model:plateColor="tableParams.plateColor"
            v-model:plateNo="tableParams.plateNo"
            ref="plateNoRef"
          />
        </el-form-item>

        <el-form-item label="车辆颜色" prop="vehicleColor">
          <h-selectcode
            type="vehicle_color_six"
            v-model="tableParams.vehicleColor"
            placeholder="请选择"
            bx="bx"
          ></h-selectcode>
        </el-form-item>
        <el-form-item label="车辆类型" prop="vehicleClass">
          <h-selectcode
            type="carType"
            v-model="tableParams.vehicleClass"
            placeholder="请选择"
            bx="bx"
          ></h-selectcode>
        </el-form-item>

        <el-form-item label="车辆品牌" prop="vehicleBrands">
          <h-selectcode
            type="vehicle_brand"
            placeholder="车辆品牌"
            v-model="tableParams.vehicleBrands"
          ></h-selectcode>
        </el-form-item>
        <!-- 查询时间 -->
        <el-form-item label="查询时间">
          <h-date-timerange
            v-model:end="tableParams.endTime"
            v-model:start="tableParams.beginTime"
            :clearable="false"
          >
          </h-date-timerange>
        </el-form-item>
        <!-- 分析范围 -->
        <el-form-item label="分析范围">
          <h-button @click="allClick" v-if="currentEquipment.length == 0"
            >全部设备</h-button
          >
          <h-button @click="allClick" v-else
            >已选择{{ currentEquipment.length }}处卡口</h-button
          >
        </el-form-item>
        <!-- 查询导出按钮 -->
        <el-form-item>
          <h-button type="primary" @click="refreshTable">查询</h-button>
          <el-button @click="resetForm(formRef)">重置</el-button>
          <!-- <h-button>导出</h-button> -->
        </el-form-item>
      </el-form>
      <div class="box-card-content">
        <div
          v-loading="loading"
          class="card-content"
          v-if="dataList.length !== 0"
        >
          <div v-for="o in dataList" :key="o" class="card-item">
            <el-card class="card-item-content">
              <img
                v-if="o.vehicleUrlHttp"
                :src="o.vehicleUrlHttp"
                class="image"
                @click="detailClick(o)"
              />
              <img
                v-else
                class="image"
                src="~@/assets/images/moren.png"
                alt=""
              />

              <div class="plate">
                <h-car-plate
                  class="plateNo"
                  v-if="o.plateNo"
                  :colorData="colorDict"
                  :type="o.plateColor"
                >
                  {{ o.plateNo }}
                </h-car-plate>
                <div class="times">
                  <p class="text-ellipsis">
                    {{ o.deviceName ? o.deviceName : "--" }}
                  </p>
                  <p>
                    {{
                      o.snapTime
                        ? moment(parseInt(o.snapTime)).format(
                            "YYYY-MM-DD HH:mm:ss"
                          )
                        : "--"
                    }}
                  </p>
                </div>
              </div>
            </el-card>
          </div>
        </div>
        <el-empty v-loading="loading" description="暂无数据" v-else></el-empty>
      </div>
      <div class="pager">
        <el-pagination
          v-model:currentPage="tableParams.page"
          v-model:page-size="tableParams.limit"
          :page-sizes="[20, 50, 70, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
      <bayonet-transfer-application
        @transferApplicationList="getTransferList"
        v-model:visible="moveVisible"
        v-show="moveVisible"
      ></bayonet-transfer-application>
      <carDetailDialog
        v-if="carDetailVisible"
        v-model:visible="carDetailVisible"
        :itemInfo="carDetailItem"
        :tableParams="tableParams"
      ></carDetailDialog>
    </el-card>
  </div>
</template>

<script>
import { defineComponent, nextTick, reactive, toRefs, ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import moment from "moment";
import {
  recordWithTotal,
  propRetrievalV2,
} from "@/api/smartApplication/smartApplicationApi.js";
import { carlist } from "@/api/realHouse/realHouse.js";
import { getDict } from "@/api/constant";
import { formatDateHMS } from "@/utils/index.js";
import bayonetTransferApplication from "@/views/publicSecurityResearch/keyKehicles/components/bayonetTransferApplication";
import _ from "lodash";
export default defineComponent({
  name: "vehicleSearch",
  components: { bayonetTransferApplication },
  props: {},
  setup(props) {
    const state = reactive({
      loading: false,
      total: 0,
      tableParams: {
        vehicleColor: "",
        vehicleClass: "",
        name: "",
        carName: "",
        plateNo: "",
        vehicleBrands: "",
        plateColor: "",
        deviceIds: [],
        beginTime: formatDateHMS(new Date().getTime() - 24 * 3600 * 1000 * 7),
        endTime: formatDateHMS(new Date()),
        page: 1,
        limit: 20,
      },
      dataList: [],
      colorDict: [],
      currentEquipment: [],
      moveVisible: false,
      carDetailVisible: false,
      carDetailItem: {},
    });
    const ruleFormRef = ref(null);
    // 获取数据字典
    const queryMenuType = async () => {
      const resCarColor = await getDict("car_card_color");
      nextTick(() => {
        state.colorDict = resCarColor.dict;
      });
    };
    queryMenuType();
    const handleSizeChange = (val) => {
      console.log(`${val} items per page`);
      state.tableParams.limit = val;
      refreshTable();
    };
    const handleCurrentChange = (val) => {
      state.tableParams.page = val;
      refreshTable();
      console.log(`current page: ${val}`);
    };
    const refreshTable = async () => {
      state.loading = true;
      const from = JSON.parse(JSON.stringify(state.tableParams));
      for (const key in from) {
        if (from[key] === "") {
          delete from[key];
        }
      }
      if (state.tableParams.vehicleBrands !== "") {
        from.vehicleBrands = [from.vehicleBrands];
      }
      propRetrievalV2(from).then(
        (res) => {
          state.dataList = res.page.list;
          state.total = res.page.totalCount;
          state.loading = false;
        },
        () => {
          state.loading = false;
        }
      );
    };
    // refreshTable();
    // 重置表单
    const resetForm = () => {
      if (!ruleFormRef.value) return;
      state.tableParams.deviceIds = [];
      state.tableParams.plateColor = "";
      state.tableParams.plateNo = "";
      ruleFormRef.value.resetFields();
    };
    const colorData = (key) => {
      let color = "";
      switch (key) {
        case "绿":
          color = "#81BC7A";
          break;
        case "黑":
          color = "#000000";
          break;
        case "蓝":
          color = "#0D29E4";
          break;
        case "黄":
          color = "#F9C613";
          break;
        case "白":
          color = "#eeeeee";
          break;
        case "黄绿":
          break;
        default:
          break;
      }
      return color;
    };
    // 获取穿梭框数据
    const getTransferList = (val) => {
      state.moveVisible = false;
      state.currentEquipment = val;
      state.tableParams.deviceIds = [];
      val.forEach((element) => {
        state.tableParams.deviceIds.push(element.deviceId);
      });
    };
    const allClick = () => {
      state.moveVisible = true;
    };
    // 详情弹窗
    const detailClick = (item) => {
      state.carDetailItem = item;
      state.carDetailVisible = true;
    };
    // 获取结构树
    const searchAsync = async (queyString, cb) => {
      if (!state.tableParams.name) return;
      state.tableParams.plateNo = "";
      state.tableParams.plateColor = "";
      const form = {
        prisonName: state.tableParams.name,
        isPage: false,
      };
      clearTimeout(data.timeOut);
      state.timeOut = setTimeout(async () => {
        const res = await carlist(form);
        if (res.code == 0) {
          res.page.list.forEach((element) => {
            element.value =
              element.prisonInfo.name +
              "   " +
              element.carProvinceDict +
              element.carNumber;
          });
          cb(res.page.list);
        }
      }, 1000);
    };
    // 点击结构树
    const handleSelect = async (item) => {
      state.tableParams.name = item.prisonInfo.name;
      state.tableParams.plateNo = item.carProvinceDict + item.carNumber;
      state.tableParams.plateColor = item.carCardColor;
    };
    return {
      ...toRefs(state),
      moment,
      colorData,
      refreshTable,
      handleSizeChange,
      handleCurrentChange,
      getTransferList,
      allClick,
      detailClick,
      resetForm,
      ruleFormRef,
      searchAsync,
      handleSelect,
    };
  },
});
</script>

<style lang="scss" scoped>
.vehicleSearch {
  width: 100%;
  height: 100%;
  .el-card {
    height: 100%;
  }
  .userForm {
    height: 100px;
  }
  .box-card-content {
    height: calc(100% - 110px);
    overflow: auto;
    .card-content {
      display: grid;
      grid-template-columns: repeat(auto-fill, 310px);
      grid-template-rows: repeat(auto-fill, 256px);
      grid-gap: 24px 0px;
      justify-content: space-around;
      .card-item {
        /deep/.el-card__body {
          padding: 10px;
        }

        .card-item-content {
          width: 100%;
          height: 260px !important;
          @include flex-col-sb-s;
          /deep/.el-card__body {
            width: 100%;
          }
          .image {
            width: 100%;
            height: 80%;
          }
          .plate {
            margin-top: 8px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            .times {
              width: 55%;
              @include flex-col-c-c;
              p {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
  .pager {
    margin-top: 8px;
  }
}
</style>
